app.controller('BrowseProductListHettichController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const navigationIDs = $scope.navigation_ids;

    $scope.product_model = $rootScope.factory.product_hettich.getModel(navigationIDs);
    $scope.product_model.apiRequire()

    $scope.isProductFiltered = function (selectID, product) {
        const parentCategoryID = navigationIDs.parent_category_id ? navigationIDs.parent_category_id : selectID;
        if (parentCategoryID) {
            if (!product.parent_category_ids || !product.parent_category_ids.includes(parentCategoryID)) {
                return true;
            }
        }
        return false;
    }

    $scope.addToCartHandler = function (validateFormCallback, product) {
        const categoryCartID = $scope.category_cart_id ? $scope.category_cart_id : null;

        const hingeOption = product.option_term_ids.hinge_option;

        const orderLine = {

            type: "hettich",
            product_code: product.api_code,

            quantity: product.quantity,
            cost: product.displayPrice(),

            range: product.getSubmitRangeID(),
            colour: product.option_term_ids.hettich_colour,

            push_to_open: hingeOption === "pto",
            soft_close: hingeOption === "sc",

            category_cart_id: categoryCartID,

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,

            group_name: product.group_name
        };

        const orderBuild = {
            range: orderLine.range,
            lines: [orderLine]
        };


        $rootScope.service.product.addToCart(orderBuild, function (success, messages) {
            if (success) {
                $rootScope.service.product.resetProduct(product);
            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        });
    };

    $scope.list_item_include = "views/browse/product/browse-product-item-hettich.htm";
    $scope.list_current_txt = "Current Category";


}]);